import React from "react";

const Confirmation = ({ open, module, onDelete, onCancel, onConfirm }) => {
  return (
    <div
      className="card confirmation"
      style={{ display: open ? "block" : "none" }}
    >
      <div className="confirmation__content">
        <h2 className="card__heading confirmation__heading">Confirmation</h2>
        <p>
          Are you sure, you want to{" "}
          {module === "logout" ? "logout" : "delete the"} {module}?
        </p>
        {module !== "logout" ? (
          <button className="btn btn--primary" onClick={onDelete}>
            Delete
          </button>
        ) : (
          <button className="btn btn--primary" onClick={onConfirm}>
            Confirm
          </button>
        )}
        &nbsp;
        <button className="btn btn--secondary" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default Confirmation;
